import Swiper from 'swiper/bundle'

document.querySelectorAll('.s1025').forEach((wrapper) => {
  const swiperEl = wrapper.querySelector('.s1025-swiper')
  const customPagination = wrapper.querySelector('.custom-swiper-pagination')
  const maxDots = 5

  const swiper = new Swiper(swiperEl, {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 30,
    effect: 'fade',
    speed: 750,
    navigation: {
      nextEl: swiperEl.querySelector('.button-next'),
      prevEl: swiperEl.querySelector('.button-prev'),
    }
  })

  function updateCustomPagination() {
    if (!customPagination) return

    const current = swiper.realIndex
    const total = swiper.slides.length

    customPagination.innerHTML = ''

    let start = Math.max(0, current - 1)
    let end = Math.min(total, start + maxDots)

    if (end - start < maxDots && start > 0) {
      start = Math.max(0, end - maxDots)
    }

    for (let i = start; i < end; i++) {
      const dot = document.createElement('button')
      dot.className = 'dot' + (i === current ? ' active' : '')
      dot.addEventListener('click', () => swiper.slideTo(i))
      customPagination.appendChild(dot)
    }
  }

  updateCustomPagination()
  swiper.on('slideChange', updateCustomPagination)
})
